<template>
  <div class="map-page">
    <hei-studies-map
      :studies="mappedValues"
      :studiesByType="studiesData"
    ></hei-studies-map>
  </div>
</template>

<script>
import HeiStudiesMap from "@/components/HeiStudiesMap.vue"; // @ is an alias to /src
import myMixin from "../mixins.js";

export default {
  name: "hei-map-page",
  mixins: [myMixin],
  created: function() {
    this.fetchData();
  },
  components: {
    HeiStudiesMap,
  },
};
</script>

<style lang="scss" scoped>
.map-page {
}
</style>
